const Dimensions = ['width', 'height'] as const;

/** Classic Outlook sizes images from their width/height attributes and ignores CSS sizes, while every other client
 * uses the CSS. Dragging a corner in the editor writes the new height to CSS only when the image already has a CSS
 * height (ours get height:auto on insert), leaving the old height attribute behind, so the image stretches in Outlook. */
export const hasOutlookImageSizeConflict = (images: Iterable<HTMLImageElement>) => {
	for (const image of images) {
		for (const dimension of Dimensions) {
			const cssValue = image.style[dimension];
			const attributeValue = Number.parseFloat(image.getAttribute(dimension) ?? '');
			if (cssValue.endsWith('px') && !Number.isNaN(attributeValue)) {
				if (Math.abs(Number.parseFloat(cssValue) - attributeValue) > 1) {
					return true;
				}
			}
		}
	}
	return false;
};
